<div class="grid grid-cols-12 my-10 px-3 sm:px-5 lg:px-0">
  <div class="col-start-2 col-span-10 lg:col-span-6 lg:col-start-4">
    <h2 class="w-full  text-center justify-center text-gray-900 text-4xl font-extrabold font-['Inter'] leading-10">
      Favorites</h2>
    <p class="text-center justify-start text-gray-500 text-xl font-normal font-['Inter'] leading-8 mt-4 ">
      Ao adicionar um imóvel aos favoritos, você receberá automaticamente notificações sobre quando a data do leilão estiver proxima.
    </p>
  </div>
</div>

<div class="grid grid-cols-12 mt-10 mb-20 px-3 sm:px-5 lg:px-0">
  <div class="col-start-1 col-span-12 md:col-start-2 md:col-span-10 xl:col-span-10 xl:col-start-2">
    @if(loading){
      <!-- Loading indicator -->
      <div class="flex justify-center items-center py-10">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-900"></div>
      </div>
    }
    @if (!loading && (favoriteRealEstates$ | async)?.length === 0) {
      <!-- No favorites message -->
      <div class="text-center py-10">
        <p class="text-gray-500">Você ainda não tem imóveis favoritos.</p>
      </div>

    }
    <!-- Real estate cards grid -->
    <div class="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-3">
      @for (realEstate of favoriteRealEstates$ | async; track realEstate.link;) {
        <app-real-estate-card [realEstate]="realEstate"></app-real-estate-card>
      }
    </div>
  </div>
</div>
